.scroller-list-grid-hero {
  width: fit-content;
  padding: 0;
  margin-bottom: 0;
  list-style: none;
  --grid-gap: 20px;

  display: grid;
  grid-auto-flow: column;
  gap: var(--grid-gap);
}

.scroller-item {
  flex-shrink: 0;
  scroll-snap-align: center;
  /* padding for focus outline */
  padding-inline: 4px;

  &:first-child {
    /* adds the margin to the first and last child of each swimlane */
    margin-left: var(--rds-gutter);
  }

  &:last-child {
    /* adds the margin to the first and last child of each swimlane */
    margin-right: var(--rds-gutter);
  }
}

.scroller-title-wrapper {
  display: flex;
  align-items: center;
}

.scroller-title-wrapper h2 {
  margin-right: 0;
}

.scroller-title-wrapper a {
  margin-left: 1.5rem;
}

/* a visually hidden heading is out of flow, so the link that follows it carries the gutter itself */
.scroller-title-wrapper :global(.sr-only) + a {
  margin-left: var(--rds-gutter);
}

.core-scroll-container {
  /* --margin: var(--rds-gutter); */
  display: flex;
  align-items: center;
  margin-inline: var(--margin);

  & .scroll-navigation-arrow {
    /* display scrollArrows for desktop but never for touch devices */
    @media (pointer: fine) {
      display: block !important;
      box-shadow: var(--rds-box-shadow--default);
    }
  }

  & .core-scroll-element {
    /* Removes scrollbars in firefox */
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
    flex-grow: 1;

    @media only screen and (pointer: coarse) {
      scroll-snap-type: x mandatory;
    }
  }
  & button {
    @media only screen and (pointer: fine) {
      display: block;
      opacity: 0.6;
    }
  }
}

.core-scroll-navigation-wrapper {
  display: flex;
  justify-content: center;
  gap: 1.25rem;

  & .core-scroll-navigation-dots {
    cursor: pointer;
    background-color: var(--rds-foreground-tertiary);
    border: none;
    border-radius: 100%;
    padding: 0.3rem;

    &[data-selected] {
      background-color: var(--rds-heading-accent);
    }
  }
}
